module.exports = __webpack_public_path__ + "static/media/32_A.b6806cb2.png";